import { createAction } from 'redux-act';

export const IncrementRequestCount = createAction('Increment the request count');
export const DecrementRequestCount = createAction('Decrement the request count');
export const AddAPIMessages = createAction('Add API Messages');
